export default __webpack_public_path__ + "static/media/logo-square.d162284b.svg";